<style>
  .children-module-content {
    /* background: transparent !important; */
    padding: 25px !important;
  }
</style>
<template>

  <div class="children-container">
    <div class="children-module-name"><span>单位信息认证</span> <span style="color: #008276;font-size: 12px;margin-left: 20px">(仅针对课题组负责人/PI/企业单位)</span></div>
    <div class="children-module-info">
      <div>
        <a-button style="margin-bottom: 20px;border-radius: 0px 16px 0px 16px;" type="primary" @click="openModal"
          icon="plus">添加
        </a-button>
      </div>
      <a-table :columns="columns" bordered :data-source="list" rowKey="id" :pagination="false">
        <template slot="state" slot-scope="text, record">
          <a-tag color="green" v-if="text == 'PASS'">通过</a-tag>
          <a-tag v-if="text == 'NONE'">等待审核</a-tag>
          <a-tag color="red" v-if="text == 'NOPASS'">审核拒绝</a-tag>
          <!-- <div v-if="text == 'NOPASS'" style="margin-top: 5px;line-height: 20px;">{{record.nopass_info}}</div> -->
        </template>
<!--        <template slot="expandedRowRender" slot-scope="record">-->
<!--          <div style="display: flex;">-->
<!--            <div style="flex: 1;">-->
<!--              <div style="text-align: left !important;line-height: 24px;"><span>单位名称:-->
<!--                </span><span>{{record.name}}</span></div>-->
<!--              <div style="text-align: left !important;line-height: 24px;"><span>纳税人识别号:-->
<!--                </span><span>{{record.card_number}}</span></div>-->
<!--              <div style="text-align: left !important;line-height: 24px;"><span>地区:-->
<!--                </span><span>{{record.province}}{{record.city}}{{record.area}}</span></div>-->
<!--              <div style="text-align: left !important;line-height: 24px;"><span>详情信息:-->
<!--                </span><span>{{record.info}}</span></div>-->
<!--            </div>-->
<!--            <div style="display: flex;width: 300px;">-->
<!--              <div><img style="width: 100px;height: 140px;margin-right: 10px;" :src="record.img_url1" alt="" /></div>-->
<!--              <div><img style="width: 165px;height: 104px;" :src="record.img_url2" alt="" /></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--        <template slot="action" slot-scope="text, record">-->
<!--          <span style="margin-left: 10px;cursor: pointer;" @click="openEditModal(record)">-->
<!--            <a-icon type="edit"  style="margin-right: 10px;"/><span>编辑</span>-->
<!--          </span>-->
<!--        </template>-->
      </a-table>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow"
          v-model="page.start" @change="changePage" />
      </div>


      <!-- <div style="margin-bottom: 40px;display: flex;align-items: center;">
        <div style="margin-right: 5px;"><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAABu0lEQVQ4jZ3UzYtOcRQH8M8jL82CmqawEGVH8lJKtrKwUyjvIUp2ksxCz4JJGiVZEAqFZsmGEv+AhcUU0SivKVJDssCg0cl5mjv33sfz8N3c3++8fH/nnt/3/BqOH9EFLuMn9pdDx5uDk/ZTu2FDX8XSBkXCXszDo5rQq1lhBY2B/hV4Nd4c/BS+KYWAHRjGtlLSzEjA21wXsR0PsbVlKxKexyWsz/1y3MHHPGg417exJGM24hwutkiKv/wLB3K9CTcwgn14kPbVOFSoakM3l7IoyW5hF8YKvjhgKP3xXYZnZcK+7M07fEcT77GnRNbCWB4UREdj3Rjo78EcfIkevsZLXMiEdbiGbxWqCXzF9YyVvQ+O51HhUszCm6y4N2+1EyJ+dsYcxGl8DoIXpcRRLOxAFpiPD/5My2jmTZJNC/dSkz0VzwTCtxN3y446wmOYm9MxveJlRvY4LvNE2Vknm5GclqHU25nUYQOrcDhbsqUsmXaEgZtYiZM5BdPS/iMnZTMeV7L+QigTdmMxFqQtbv9JjmAtOj1fIYUQcRFXsPd/CWO2T2Ft7u/XyOyfCGMi4o08G3LDGjxtG43f/cxjjuxJjRYAAAAASUVORK5CYII="
            alt=""></div>
        <div class="tips-text" v-if="state == false">您正在进行企业用户认证操作</div>
        <div class="tips-text" v-else>
          <span v-if="formModel.state == 'NONE'">您提交的信息正在审核中</span>
          <span v-if="formModel.state == 'PASS'">恭喜您，您提交的信息认证成功</span>
          <span v-if="formModel.state == 'NOPASS'">信息审核被拒绝，请按要求填写</span>
        </div>
      </div> -->

    </div>
    <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="modalVisible" title="单位信息认证" @ok="actionData"
      :width="650" :destroyOnClose="true" :disabled="$store.state.requestLoading">
      <a-form-model ref="formModel" :rules="formModelRules" :model="formModel" layout="vertical"
        :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="姓名" prop="user_name" v-if="formModel.name == ''">
          <a-input placeholder="请输入姓名" v-model="formModel.user_name"></a-input>
        </a-form-model-item>
        <a-form-model-item label="单位名称" prop="name">
          <a-select show-search label-in-value v-model="formModel.name" placeholder="请输入单位名称搜索" style="width: 100%"
                    :filter-option="false" @search="companySearch" @change="companySelect">
            <a-select-option v-for="(d, index) in companyList" :key="index">
              {{ d.Name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="纳税识别号" prop="card_number">
          <a-input placeholder="请输入纳税识别号" v-model="formModel.card_number"></a-input>
        </a-form-model-item>
        <a-form-model-item label="单位所在地" prop="area_id">
          <address-select :type.sync="formModel.id  ? 'edit' : 'add'"
                          :ids="{pid: formModel.province_id, cid: formModel.city_id, aid: formModel.area_id}"
                          @addressSelect="addressSelect" />
        </a-form-model-item>
<!--        <a-form-model-item label="单位详细地址" prop="info">-->
<!--          <a-textarea placeholder="请输入单位详细地址" v-model="formModel.info" :auto-size="{ minRows: 4, maxRows: 4 }">-->
<!--          </a-textarea>-->
<!--        </a-form-model-item>-->

<!--        <a-form-model-item label="营业执照">-->
<!--          <private-picture-upload :img_url.sync="formModel.img_url1_list" :size="1" @pictureChange="img1Change"-->
<!--            width="200px" height="283px" text.sync="上传图片"></private-picture-upload>-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="实验动物使用许可证" prop="img_url2">-->
<!--          <private-picture-upload :img_url.sync="formModel.img_url2_list" :size="1" @pictureChange="img2Change"-->
<!--            :width="'330px'" :height="'208px'" text.sync="上传图片"></private-picture-upload>-->
<!--        </a-form-model-item>-->
        <a-form-model-item label="审核时间" v-if="formModel.state == 'PASS' || formModel.state == 'NOPASS'">
          <div style="padding-top: 6px;">{{formModel.state_time}}</div>
        </a-form-model-item>
        <a-form-model-item label="拒绝理由" v-if="formModel.state == 'NOPASS'" style="color: #f50;">
          <div style="padding-top: 6px;">{{formModel.nopass_info}}</div>
        </a-form-model-item>

        <!-- <template v-if="formModel && (formModel.state == 'PASS' || formModel.state == 'NOPASS')">
          <a-form-model-item :wrapper-col="{ span: 10, offset: 4 }">
            <a-button type="primary" block @click="actionData">
              <span>重新认证</span>
            </a-button>
          </a-form-model-item>
        </template> -->
        <!-- <template v-if="state == false">
          <a-form-model-item :wrapper-col="{ span: 10, offset: 4 }">
            <a-button type="primary" block @click="actionData">
              <span>确定</span>
            </a-button>
          </a-form-model-item>
        </template> -->
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import * as Api from './api';
  import * as commonApi from '@/commonApi';

  export default {
    data() {
      return {
        modalVisible: false,
        page: {
          start: 1,
          limit: 20,
          pageSize: 0,
          totalRow: 0,
        },
        list: [],
        companyList: [],
        formModel: {
          type: 'ENTERPRISE',
          name: undefined,
          user_name: '',
          card_number: '',
          img_url1: '',
          img_url1_list: [],
          img_url2: '',
          img_url2_list: [],
          province_id: '',
          city_id: '',
          area_id: '',
          info: '',
          state: ''
        },
        user: {},
        formModelRules: {
          user_name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
          name: [{ required: true, message: '请输入单位名称', trigger: 'change' }],
          card_number: [{ required: true, message: '请输入纳税识别号', trigger: 'change' }],
          // img_url1: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
          // img_url2: [{ required: true, message: '请上传动物实验许可证', trigger: 'change' }],
          area_id: [{ required: true, message: '请选择地区', trigger: 'change' }],
          info: [{ required: true, message: '请输入详细信息', trigger: 'change' }]
        },
        state: false,
        columns: [
          {
            title: "单位名称",
            dataIndex: "name",
            scopedSlots: { customRender: "name" },
          },
          {
            title: "税号",
            dataIndex: "tax_number",
            scopedSlots: { customRender: "tax_number" },
            width: 250
          },
          // {
          //   title: "",
          //   dataIndex: "tax_number",
          //   scopedSlots: { customRender: "tax_number" },
          //   width: 250
          // },
          // {
          //   title: "审核状态",
          //   dataIndex: "state",
          //   scopedSlots: { customRender: "state" },
          //   width: 150
          // },
          //
          // {
          //   title: "提交时间",
          //   dataIndex: "create_time",
          //   scopedSlots: { customRender: "create_time" },
          //   width: 200
          // },
          // {
          //   title: "操作",
          //   dataIndex: "action",
          //   scopedSlots: { customRender: "action" },
          //   width: 150
          // },
        ]
      };
    },
    mounted() {
      this.getPage();
      this.getUserInfo();
    },
    methods: {

      // 打开添加框
      openModal() {
        if (this.user.mobile == null) {
          this.$message.error('请完善个人资料手机绑定后添加');
          return;
        }
        if (this.user.mail == '') {
          this.$message.error('请完善个人资料邮箱绑定后添加');
          return;
        }
        this.formModel['id'] = '';
        this.formModel.name = undefined;

        this.formModel.card_number = '';
        this.formModel.img_url1 = '';
        this.formModel.img_url1_list = [];
        this.formModel.img_url2 = '';
        this.formModel.img_url2_list = [];
        this.formModel.province_id = '';
        this.formModel.city_id = '';
        this.formModel.area_id = '';
        this.formModel.info = '';
        this.modalVisible = true;
      },

      // 用户信息
      async getUserInfo() {
        let res = await Api.GetUserInfo({});
        if (res && res['code'] == '0') {
          if (res && res.user != null) {
            this.formModel.user_name = res.user.name;
            this.user = res.user;
          }
        }
      },

      // 打开编辑框
      async openEditModal(record) {
        console.log(record)

        let res = await Api.Detail({ id: record.id });
        if (res && res.code == 0) {
          this.formModel = res.target;
          this.formModel.name = {label: this.formModel.name, key: 0};

          let temp1 = res.target.img_url1.split('?');
          let temp2 = res.target.img_url2.split('?');
          this.formModel.img_url1 = temp1[0];
          this.formModel.img_url1_list = [{ url: temp1[0], query: temp1[1] }];
          this.formModel.img_url2 = temp2[0];
          this.formModel.img_url2_list = [{ url: temp2[0], query: temp2[1] }]
          this.modalVisible = true;
          console.log(this.formModel)
        }
      },

      // 获取列表
      async getPage() {
        let res = await Api.GetPage(this.page);
        if (res && res["code"] == "0") {
          this.list = res.page.list;
          this.page.totalRow = res.page.totalRow;
          this.page.pageSize = res.page.pageSize;
        }
      },

      // 获取信息
      async getAuthentication() {
        let res = await Api.GetAuthentication({});
        if (res && res["code"] == "0") {
          if (res.target) {
            this.state = true;
            let temp1 = res.target.img_url1.split('?');
            let temp2 = res.target.img_url2.split('?');
            this.formModel = Object.assign(this.formModel, res.target);
            this.formModel.img_url1 = temp1[0];
            this.formModel.img_url1_list = [{ url: temp1[0], query: temp1[1] }];
            this.formModel.img_url2 = temp2[0];
            this.formModel.img_url2_list = [{ url: temp2[0], query: temp2[1] }];

          }
        }
      },

      // 切换分页
      changePage(e) {
        this.page.start = e;
        this.getPage();
      },

      // 地址选择
      addressSelect(data) {
        this.formModel.province_id = data.province_id;
        this.formModel.city_id = data.city_id;
        this.formModel.area_id = data.area_id;
        this.$refs.formModel.validateField('area_id')
      },

      // 图片1
      img1Change(e) {


        this.img_url1_list = e;
        this.formModel.img_url1 = e.list[0].url;
        if (e.type == 'add') {
          this.$refs.formModel.validateField('img_url1')
        }
      },

      // 图片2
      img2Change(e) {
        this.img_url1_list = e;
        this.formModel.img_url2 = e.list[0].url;
        if (e.type == 'add') {
          this.$refs.formModel.validateField('img_url2')
        }
      },

      // 提交数据
      async actionData() {

        this.$refs.formModel.validate(async valid => {
          if (valid) {
            let params = Object.assign({}, this.formModel)
            params.name = (params.name.label).trim();
            let res = null;
            if (!this.formModel.id) {
              res = await Api.Save(params);
            } else {
              res = await Api.Edit(params);
            }
            if (res && res['code'] == '0') {
              this.$message.success(res.message);
              this.getPage()
              this.modalVisible = false;
            } else {
              this.$message.error(res.message);
            }
          }
        });
      },
      // 根据名字查询企业列表
      async companySearch(e) {
        if (e.length >= 3) {
          this.companyList = [];
          let res = await Api.GetNameList({ name: e });
          if (res && res.code == 0) {
            this.companyList = res.list;
          }
        } else {
          this.companyList = [];
          this.formModel.tax_number = '';
        }
      },

      // 选择企业
      companySelect(company) {
        this.formModel.card_number = this.companyList[company.key].CreditCode;
        this.companyList = [];
        this.companySelectVisible = false;
      }
    },
  };
</script>

<style lang="less">
  .tips-text {
    font-size: 14px;
    font-weight: 500;
    color: #007F76;
    line-height: 38px;
    padding-top: 2px;
  }

  .code {
    background-color: #007F76;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
</style>
